module.exports = __webpack_public_path__ + "static/hero-cans-de-DE-2291ac052c1546b35a7fa100564bd1ae.png";